/*!
 * KoliBri - The accessible HTML-Standard
 */
import { O as watchNumber } from './common-D-vggmh2.js';

const validateRows = (component, value) => {
    watchNumber(component, `_rows`, value, { min: 1 });
};

export { validateRows as v };
//# sourceMappingURL=rows-DlWRIMNQ.js.map

//# sourceMappingURL=rows-DlWRIMNQ.js.map